import React from "react";

const StepContent4 = ({ previousData }) => {
  const name = previousData && previousData.name ? previousData.name : "—";
  const age = previousData && previousData.age ? previousData.age : "—";
  const city = previousData && previousData.city ? previousData.city : "—";

  return React.createElement(
    "div",
    { className: "step-content" },
    React.createElement("h2", null, "Шаг 4: Итог"),
    React.createElement(
      "p",
      null,
      "Данные, собранные с предыдущих шагов:"
    ),
    React.createElement(
      "ul",
      { className: "summary-list" },
      React.createElement(
        "li",
        null,
        React.createElement("strong", null, "Имя:"),
        " ",
        name
      ),
      React.createElement(
        "li",
        null,
        React.createElement("strong", null, "Возраст:"),
        " ",
        age
      ),
      React.createElement(
        "li",
        null,
        React.createElement("strong", null, "Город:"),
        " ",
        city
      )
    ),
    React.createElement(
      "p",
      null,
      "Вы можете кликать по шагам на дорожке сверху, чтобы возвращаться и изменять данные. Передача значений между пунктами сохраняется."
    )
  );
};

export default StepContent4;


